<template>
  <div>
    <Navigation />

    <!-- Intro Section -->
    <b-row class="full-view d-flex flex-column justify-content-center align-items-center">
      <img class="logo" src="./../assets/logo.png" />
      <h1 class="main-text">Omega Tab Manager</h1>
      <b-button :href="extensionLink" target="_blank" variant="outline-primary" size="lg">
        <span class="d-flex justify-content-center align-items-center">
          <img src="./../assets/chrome.png" width="32" height="32" style="margin-right: 5px;" />
          <span>Get Extension</span>
        </span>
      </b-button>
      <b-button
        :to="releaseNotesLink"
        target="_self"
        variant="outline-dark"
        size="sm"
        class="mt-2"
      >
        <span class="d-flex justify-content-center align-items-center">
          <img src="./../assets/file-text.svg" width="16" height="16" style="margin-right: 5px;" />
          <span>Release Notes</span>
        </span>
      </b-button>
    </b-row>

    <!-- Screenshots Section -->
    <b-row class="full-view d-none d-sm-flex flex-column justify-content-center align-items-center background-blue-green">
      <div class="background-brand-blue __bg-lint-left"></div>
      <div style="width: 896px; height 560px;">
        <b-carousel
          id="carousel-1"
          :interval="4000"
          controls
          indicators
          background="#ababab"
          img-width="896"
          img-height="560"
        >
          <b-carousel-slide>
            <template v-slot:img>
              <img
                width="896"
                height="560"
                src="./../assets/screenshots/darktheme.png"
                alt="Dark Theme Screenshot"
              >
            </template>
          </b-carousel-slide>

          <b-carousel-slide>
            <template v-slot:img>
              <img
                width="896"
                height="560"
                src="./../assets/screenshots/tabsview.png"
                alt="Dark Theme Screenshot"
              >
            </template>
          </b-carousel-slide>


          <b-carousel-slide>
            <template v-slot:img>
              <img
                width="896"
                height="560"
                src="./../assets/screenshots/sessions.png"
                alt="Dark Theme Screenshot"
              >
            </template>
          </b-carousel-slide>
          
          <b-carousel-slide>
            <template v-slot:img>
              <img
                width="896"
                height="560"
                src="./../assets/screenshots/omnibox.png"
                alt="Dark Theme Screenshot"
              >
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>
    </b-row>

    <!-- Top Features Section -->
    <section class="full-view">
      <div class="background-brand-green __bg-lint-left d-block d-sm-none"></div>
      <b-row>
        <b-col class="mb-5 mt-5">
          <!-- Header -->
          <h1>Top Features</h1>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" sm="4" order="1">
          <h3>Dark Theme</h3>
          <p>Designed for both Light and Dark theme users</p>
        </b-col>
        <b-col cols="12" sm="4" order="2">
          <h3>Sessions</h3>
          <p>Continue where you left off</p>
        </b-col>
        <b-col cols="12" sm="4" order="3"> 
          <h3>Multiple tab views</h3>
          <p>Advanced views to group tabs</p>
        </b-col>
      </b-row>

      <b-row style="margin: 100px 0 0 0;">
        <b-col cols="12" order="1" class="mb-5">
          <h2>More Features</h2>
        </b-col>
        <b-col cols="12" sm="4" order="2">
          <p>Provides unique ability to close all tabs of same domain</p>
        </b-col>
        <b-col cols="12" sm="4" order="3">
          <p>Tabs are searchable via url or title</p>
        </b-col>
        <b-col cols="12" sm="4" order="4"> 
          <p>Indicates which tab is producing the sound</p>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import Navigation from "@/shared/Navigation";

export default {
  name: "MainPage",
  components: { Navigation },
  data() {
    return {
      extensionLink:
        "https://chrome.google.com/webstore/detail/omega-tab-manager/onocdaepnncepcgpakklklknhhnmhpcp",
      releaseNotesLink: "/releasenotes",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.full-view {
  min-height: 100vh;
}

.logo {
  width: 10em;
  height: 10em;
}

.main-text {
  font-size: 4em;
}

hr {
  width: 20%;
  min-width: 200px;
}

.background-brand-blue {
  background: rgb(255,255,255);
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(139,204,230,1) 100%);
}

.background-brand-green {
  background: rgb(255,255,255);
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(132,195,74,1) 100%);
}

.__bg-lint-left {
  position: absolute;
  right: 0;
  left: 0;
  height: 100%;
  transform: skewY(-3deg);
  transform-origin: top left;
}
</style>
